import * as React from "react";
import { GrnBillingInfoProps } from "../../features/grn/types";
import GrnBillingInfo from "./GrnBillingInfo";

/**
 * Wrapper that reuses the shared GrnBillingInfo implementation.
 * The legacy GRN billing panel doesn't require the extra tax percent controls,
 * so we simply toggle the flag off here.
 */
const GrnBilling: React.FC<GrnBillingInfoProps> = (props) => {
  return <GrnBillingInfo {...props} enableTaxPercentInput={false} />;
};

export default GrnBilling;
